import { AssistedHygiene } from './AssistedHygiene';
import { Date } from './Date';
import { HourlyRate } from './HourlyRate';
import { Hours } from './Hours';
import { MealBreak } from './MealBreak';
import { Professional } from './Professional';
import { SelectOffice } from './SelectOffice';
import { Specialty } from './Specialty';

export const InputJob = {
  AssistedHygiene,
  Date,
  HourlyRate,
  Hours,
  MealBreak,
  Professional,
  SelectOffice,
  Specialty,
};
